export enum PopupID {
    INFO_MENU = 'infoMenu',
    MORE_LEVELS_COMING = 'moreLevelsComingMenu',
    STAR_CHEST_INFO = 'starChestInfoMenu',
    HARVEST_MENU = 'fieldHarvestMenu',
    SPECIAL_OFFER_MENU = 'specialOfferMenu',
    SUNDAY_OFFER_MENU = 'sundayOfferMenu',
    SHOP_MENU = 'shopMenu',
    QUEST_MENU = 'questsMenu',
    DAILY_LOGIN_MENU = 'dailyLoginMenu',
    THANK_YOU_FIRST_PURCHASE = 'thankYouFirstPurchase',
    PAYER_REACTIVATION_MENU = 'payerReactivationMenu',
    PET_UNLOCK_MENU = 'petUnlockMenu',
    PRE_PET_MINIGAME_MENU = 'prePetMiniGameMenu',
    NO_COINS_MENU = 'noCoinsMenu',
    FRIENDS_HUB = 'friendsHub',
    SETTINGS_MENU = 'settingsMenu',
    THREE_STAR_SHARE_MENU = '3StarShareMenu',
    CROSS_PROMO_MENU = 'CrossPromoMenu',
    BOT_OPT_IN_MENU = 'botOptInMenu',
    WHEEL = 'Wheel',
    WHEEL_QUIT_CONFIRM = 'WheelQuitConfirm',
    LEVEL_HUD = 'levelHUD',
    HELPER_FRIEND_HUD = 'helperFriendHUD',
    CROSS_PROMO = 'CrossPromo',
    BOOSTER_HUD = 'boosterHUD',
    WORLD_HUD_TRAVEL = 'worldHUDTravel',
    WORLD_HUD = 'worldHUD',
    FIELD_UNLOCKED_MENU = 'fieldUnlockedMenu',
    CROP_UNLOCK_MENU = 'cropUnlockedMenu',
    THREE_STAR_REWARD_MENU = 'threeStarRewardMenu',
    SEND_GIFT_MENU = 'sentGiftMenu',
    GIFT_MENU = 'giftMenu',
    CROP_UNLOCKED_SHARE_MENU = 'cropUnlockedShareMenu',
    LEVEL_POPUP = 'levelPopup',
    BUY_BOOSTER_POPUP = 'buyBoosterPopup',
    LEVEL_COMPLETE_POPUP = 'levelCompletePopup',
    STREAK_INFO_POPUP = 'streakInfoPopup',
    GDPR_POPUP = 'gdprPopup',
    CONFIRM_QUIT_GAME = 'confirmQuitGame',
    ERROR_POPUP = 'errorPopup',
    CONFIRM_SIGN_OUT_MENU = 'confirmSignOutMenu',
    DATA_CONFLICT_POPUP = 'dataConflictsPopup',
    HARD_LEVEL_SHARE_POPUP = 'hardSharePopup',
    FARM_HUD = 'farmHUD',
    FARM_MAP = 'farmMap',
    FARM_AREA_UNLOCK = 'farmAreaUnlock',
    FARM_UNLOCK_ITEMS = 'farmUnlockItems',
    FARM_SHARE = 'farmShare',
    FARM_CATALOGUE = 'farmCatalogue',
    FARM_MINI_GAME = 'farmMiniGame',
    FARM_NEW_ITEMS = 'farmNewItems',
    CONNECT_FB_POPUP = 'connectFbPopup',
    CONNECT_FB_SPLASH_SCREEN = 'connectFbSplashScreen',
    PROGRESSION_PASSED_MOBILE_VERSION = 'progressionPassedMobileVersion',
    EVENT_OFFER = 'eventOfferPopup',
    EVENT_FTUX = 'eventFTUX',
    TNT_MODIFIER_WARNING = 'tntModifierWarningHUD',
    PLINKO_MINI_GAME = 'plinkoMiniGame',
    PLINKO_MINI_GAME_QUIT = 'plinkoMiniGameQuit',
    GBC_DISCONNECTED = 'GBCDisconnected',

    // Only used for EventLayoutMap.ts.
    LEVEL_POPUP_SIDE_MENU = 'levelPopupSideMenu',
    CONFIRM_QUIT_LEVEL = 'confirmQuitLevel',
}
